<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { type BadgeVariants, badgeVariants } from ".";
import { cn } from "@/lib/utils";

const props = defineProps<{
  variant?: BadgeVariants["variant"];
  class?: HTMLAttributes["class"];
  color: string
}>();
</script>

<template>
  <div
    :class="[cn(badgeVariants({ variant }), props.class), {
      'bg-gray-50 text-gray-900 ring-gray-700/40 dark:bg-gray-900 dark:text-gray-50 dark:ring-gray-300/40': color == 'gray',
      'bg-red-50 text-red-900 ring-red-700/40 dark:bg-red-900 dark:text-red-50 dark:ring-red-300/40': color == 'red',
      'bg-rose-50 text-rose-900 ring-rose-700/40 dark:bg-rose-900 dark:text-rose-50 dark:ring-rose-300/40': color == 'rose',
      'bg-yellow-50 text-yellow-900 ring-yellow-700/40 dark:bg-yellow-900 dark:text-yellow-50 dark:ring-yellow-300/40': color == 'yellow',
      'bg-orange-50 text-orange-900 ring-orange-700/40 dark:bg-orange-900 dark:text-orange-50 dark:ring-orange-300/40': color == 'orange',
      'bg-lime-50 text-lime-900 ring-lime-700/40 dark:bg-lime-900 dark:text-lime-50 dark:ring-lime-300/40': color == 'lime',
      'bg-green-50 text-green-900 ring-green-700/40 dark:bg-green-900 dark:text-green-50 dark:ring-green-300/40': color == 'green',
      'bg-blue-50 text-blue-900 ring-blue-700/40 dark:bg-blue-900 dark:text-blue-50 dark:ring-blue-300/40': color == 'blue',
      'bg-indigo-50 text-indigo-900 ring-indigo-700/40 dark:bg-indigo-900 dark:text-indigo-50 dark:ring-indigo-300/40': color == 'indigo',
      'bg-purple-50 text-purple-900 ring-purple-700/40 dark:bg-purple-900 dark:text-purple-50 dark:ring-purple-300/40': color == 'purple',
      'bg-pink-50 text-pink-900 ring-pink-700/40 dark:bg-pink-900 dark:text-pink-50 dark:ring-pink-300/40': color == 'pink',
    }]"
  >
    <slot />
  </div>
</template>
